import { apiQuery } from '../';

export const blueprintApi = apiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getBluePrints: builder.query({
        transformResponse: (response) => response.data,
        query: () => {
          return {
            method: 'get',
            url: `/blueprints/kula`,
          };
        },
      }),

      getBluePrint: builder.query({
        transformResponse: (response) => response.data,
        query: ({ blueprintId }) => {
          return {
            method: 'get',
            url: `/blueprints/${blueprintId}`,
          };
        },
      }),

      updateBlueprint: builder.mutation({
        transformResponse: (response) => response.data,
        query: ({ blueprintId, name, description }) => {
          return {
            url: `/blueprints/${blueprintId}`,
            method: 'put',
            data: { name, description },
          };
        },
      }),

      getAllBluePrint: builder.query({
        transformResponse: (response) => response.data,
        query: () => {
          return {
            method: 'get',
            url: `/blueprints`,
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useGetBluePrintsQuery,
  useGetBluePrintQuery,
  useUpdateBlueprintMutation,
  useGetAllBluePrintQuery,
} = blueprintApi;
